import { co2 } from './common';

export default {
  'consumption.co2': `${co2} انبعاثات مجتمعة`,
  'consumption.energy': 'استهلاك الطاقة في دورة الاختبار المركبة',
  'consumption.fuel': 'استهلاك الوقود مجتمعة',
  'footnotes.local': '',
  'footnotes.wltp': '',
  'footnotes.nedc':
    'تم الحصول على الأرقام الموضحة وفقًا لعملية القياس المحددة. إنها "قيم NEDC CO2" وفقًا للفن. 2 رقم 1 من اللائحة التنفيذية (الاتحاد الأوروبي) 2017/1153. تم حساب أرقام استهلاك الوقود على أساس هذه القيم. تم تحديد الاستهلاك الكهربائي على أساس التوجيه 692/2008 / EC.',
  'footnotes.emissions.appendix':
    'لمزيد من المعلومات حول الاستهلاك الرسمي للوقود وانبعاثات ثاني أكسيد الكربون لسيارات الركاب الجديدة ، يرجى الاتصال بوكيل مرسيدس-بنز المعتمد.',
  'search.input.label': '',
  'search.result.buy-online': 'شراء عبر الإنترنت',
  'search.results': 'لم يتم العثور على نتائج | {count} نتيجة البحث | {count} نتائج البحث',
  'search.results.count': '{count} نتائج البحث',
  'search.results.backup': 'لم يتم العثور على تطابقات تامة. عرض الصفحات ذات الصلة:',
  'search.results.none.summary': 'لا توجد نتائج بحث متاحة لمصطلح البحث هذا. يرجى المحاولة مرة أخرى بمصطلح مختلف.',
  'search.show-more': 'أظهر المزيد',
  'search.unavailable': 'البحث غير متوفر حاليا.',
  'search.result.new': 'الجديد',

  'search.result.consumption': 'الاستهلاك',

  'watch.video': 'شاهد الفيديو',
  'input.recently': 'آخر بحث',
  'input.help.title': 'ما الذي تبحث عنه؟',
  'input.help.text': 'ابحث باستخدام أنواع السيارات وطرازاتها وأكواد التهيئة أو عن ملحقات ومنتجات ومعلومات أخرى',

  'search.result.grid': 'Mřížka',
  'search.result.list': 'Seznam',

  'search.results.offer': '"{query}" :  عروض شائعة لـ',
};
